import { z } from 'zod'

// money spent and unrealized P&L for one time window of a broker account's bot buys.
// spent = Σ executedLots × lotSize × executionPrice; diff = Σ executedLots × lotSize ×
// (currentPrice − executionPrice); diffPercent = diff / spent × 100 (0 when spent is 0).
// only filled / partially-filled buy orders contribute; amounts are in the account currency (RUB).
export const botWindowStatsSchema = z.object({
  spent: z.number(),
  diff: z.number(),
  diffPercent: z.number(),
})
export type BotWindowStatsDto = z.infer<typeof botWindowStatsSchema>

// per-window money-spent + unrealized-diff stats for one broker account's bot
export const botMonitorStatsSchema = z.object({
  accountName: z.string(),
  botEnabled: z.boolean(),
  today: botWindowStatsSchema,
  last7d: botWindowStatsSchema,
  last30d: botWindowStatsSchema,
})
export type BotMonitorStatsDto = z.infer<typeof botMonitorStatsSchema>
